import React, { memo } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./MyDatePicker.css";

const MyDatePicker = ({
  selected,
  onSelect,
  onChange,
  disabled = false,
  className,
  showMonthDropdown = true,
  showYearDropdown = true,
  // dateFormat = "MM-dd-yyyy hh:mm",
  dateFormat = "yyyy-MM-dd, HH:mm",
}) => {
  return (
    <div className="relative date-picker-wrapper">
      <DatePicker
        showMonthDropdown={showMonthDropdown}
        showYearDropdown={showYearDropdown}
        autoFocus={false}
        selected={selected}
        onSelect={onSelect}
        onChange={onChange}
        disabled={disabled}
        dateFormat={dateFormat}
        disabledKeyboardNavigation={true}
        showTimeSelect
        timeFormat={"HH:mm"}
        dropdownMode="select"
        onFocus={(e) => e.target.blur()}
        className={`
          h-12 w-full rounded-xl border-2 appearance-none px-4 py-3 text-sm font-medium
          bg-white text-gray-800 border-gray-200 
          hover:border-indigo-300 hover:shadow-md
          focus:outline-none focus:ring-4 focus:ring-indigo-100 focus:border-indigo-500
          transition-all duration-200 ease-in-out
          placeholder:text-gray-400
          disabled:bg-gray-50 disabled:text-gray-400 disabled:border-gray-200
          no-arrow custom-date-input
          ${className}
        `}
        popperClassName="calendar-popper !z-[999999]"
        calendarClassName="!border-0 !shadow-2xl !rounded-2xl !overflow-hidden"
        popperPlacement="auto"
        dayClassName={(date) => {
          const today = new Date();
          const isToday = date.toDateString() === today.toDateString();
          const isSelected = selected && date.toDateString() === selected.toDateString();
          
          if (isSelected) return "!bg-indigo-600 !text-white !font-semibold !rounded-lg";
          if (isToday) return "!bg-indigo-100 !text-indigo-700 !font-semibold !rounded-lg";
          return "!text-gray-700 hover:!bg-indigo-50 hover:!text-indigo-700 !rounded-lg";
        }}
        weekDayClassName={() => "!text-gray-500 !font-semibold !text-sm"}
        monthClassName={() => "!text-gray-800 !font-semibold"}
        yearClassName={() => "!text-gray-800 !font-semibold"}
        timeClassName={() => "!border-t-2 !border-gray-200 !pt-4 !bg-gray-50"}
        renderCustomHeader={({
          date,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div className="flex items-center justify-between px-4 py-4 bg-gradient-to-r from-indigo-50 to-blue-50 border-b-2 border-indigo-200">
            <button
              onClick={decreaseMonth}
              disabled={prevMonthButtonDisabled}
              className="p-2.5 rounded-xl hover:bg-white hover:shadow-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed group"
            >
              <svg className="w-5 h-5 text-gray-600 group-hover:text-indigo-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <div className="text-xl font-bold text-gray-800 px-4">
              {date.toLocaleDateString('el-GR', { month: 'long', year: 'numeric' })}
            </div>
            <button
              onClick={increaseMonth}
              disabled={nextMonthButtonDisabled}
              className="p-2.5 rounded-xl hover:bg-white hover:shadow-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed group"
            >
              <svg className="w-5 h-5 text-gray-600 group-hover:text-indigo-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        )}
        renderCustomTimeInput={({ value, onChange }) => (
          <div className="px-4 py-4 bg-gray-50 border-t-2 border-gray-200">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
                <svg className="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Ώρα
              </h3>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Ώρα</label>
                <input
                  type="time"
                  value={value ? value.split(' ')[1] || '' : ''}
                  onChange={(e) => {
                    const date = selected || new Date();
                    const [hours, minutes] = e.target.value.split(':');
                    const newDate = new Date(date);
                    newDate.setHours(parseInt(hours) || 0, parseInt(minutes) || 0);
                    onChange(newDate);
                  }}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-center font-medium"
                />
              </div>
              <div className="flex items-end">
                <button
                  type="button"
                  onClick={() => {
                    const now = new Date();
                    const newDate = new Date(selected || new Date());
                    newDate.setHours(now.getHours(), now.getMinutes());
                    onChange(newDate);
                  }}
                  className="w-full px-3 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors font-medium text-sm"
                >
                  Τώρα
                </button>
              </div>
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default memo(MyDatePicker);
